import styles from './style.module.scss';

const FormError = ({ message }: { message: string }) => {
  return (
    <div className={styles.formErrorMain}>
      <p className={styles.formError}>{message}</p>
    </div>
  );
};

export default FormError;
